import { useState } from "react";
import { PresetListModel } from "@/database";
import { PublishedIcon } from "@/components/PublishedIcons/PublishedIcons";

interface PresetCardListProps {
  presets: PresetListModel[];
  selectedPresetId?: string;
  onApply: (preset: PresetListModel, excludedPlatforms: string[]) => void;
  excludedByPreset: Record<string, string[]>;
  onTogglePlatform: (presetId: string, platform: string) => void;
  onOpen: (preset: PresetListModel, channelId?: string, isOn?: boolean) => void;
}

const PresetCardList = ({
  presets,
  selectedPresetId,
  onApply,
  excludedByPreset,
  onTogglePlatform,
  onOpen,
}: PresetCardListProps) => {
  const [searchTerm, setSearchTerm] = useState<string>("");

  const filteredPresets = presets.filter((preset) =>
    (preset.name || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="d-flex flex-column gap-2">
      <div className="d-flex align-items-center gap-2 border-bottom">
        <label className="mb-0" style={{ fontSize: 13 }}>
          Preset
        </label>
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ width: "140px", marginLeft: "auto", minHeight: "26px" }}
          placeholder="Search preset by title..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      {filteredPresets.map((preset) => {
        const excluded = excludedByPreset[preset.id] || [];
        const isPresetSelected = selectedPresetId === preset.id;

        return (
          <div key={preset.id} className="border bg-light rounded">
            <div className="d-flex align-items-center px-2 py-1 gap-2">
              <span
                className="flex-grow-1 text-truncate pointer"
                style={{ fontSize: 13, whiteSpace: "nowrap" }}
                onClick={() => onOpen(preset, undefined, isPresetSelected)}
              >
                {preset.name || "Untitled Preset"}
              </span>
              <div className="form-check form-switch m-0">
                <input
                  type="checkbox"
                  className="form-check-input pointer"
                  role="switch"
                  checked={selectedPresetId === preset.id}
                  onChange={() => onApply(preset, excluded)}
                />
              </div>
            </div>

            <div
              className="d-flex flex-column flex-nowrap gap-2 px-2 pb-2 border-top pt-2 bg-white"
              style={{ overflowX: "auto" }}
            >
              {(preset.social || []).map((item) => {
                const platform = item.platform || "";
                const isSelected =
                  isPresetSelected && !excluded.includes(platform);

                return (
                  <div
                    key={platform}
                    className={`d-flex align-items-center gap-1 border-bottom pb-2 py-1 w-100 ${
                      isSelected ? "border-secondary/20" : "text-muted"
                    }`}
                  >
                    <PublishedIcon
                      job_type={platform}
                      status={isSelected ? 10 : 0}
                      size={14}
                      showQuestionCircle={false}
                    />
                    <span
                      className="pointer"
                      style={{ fontSize: 12 }}
                      onClick={() => onOpen(preset, platform, isSelected)}
                    >
                      {(item as any).channel_name || platform}
                    </span>
                    <div className="form-check form-switch ms-auto">
                      <input
                        type="checkbox"
                        className="form-check-input pointer"
                        role="switch"
                        checked={isSelected}
                        onChange={() => onTogglePlatform(preset.id, platform)}
                      />
                    </div>
                  </div>
                );
              })}
              {(!preset.social || preset.social.length === 0) && (
                <span className="text-muted" style={{ fontSize: 12 }}>
                  No platforms in this preset
                </span>
              )}
            </div>
          </div>
        );
      })}
      {filteredPresets.length === 0 && (
        <div className="text-center text-muted py-3" style={{ fontSize: 13 }}>
          No presets found
        </div>
      )}
    </div>
  );
};

export default PresetCardList;
